<div class="measurements-modal">
  <div class="flex justify-center">
    @if (loading$ | async) {
    <fip-loading-spinner
      class="absolute left-2/4 top-2/4"
    ></fip-loading-spinner>
    } @else { @if (dataState === ComponentDataState.HasData) { @if (chartData) {
    <div class="flex-1 p-4">
      <fip-line-chart
        [dataPoints]="chartData"
        [yTitle]="yAxisLabel"
        [xTicksVals]="xTicksVals"
        [xTicksLabels]="xTicksLabels"
        [width]="900"
        [setAutoMinYValue]="true"
      ></fip-line-chart>
    </div>
    } } @if (dataState === ComponentDataState.NoData) { No data available. } }
  </div>
</div>
